export default __webpack_public_path__ + "static/media/CFx-logoCopy.d602e205.png";